import { Link } from "react-router-dom";
import type { Article } from "@/lib/insights";
import { getCategoryColor } from "@/lib/insights";

export function ArticleCard({ article }: { article: Article }) {
  return (
    <Link
      to={`/insights/${article.slug}`}
      className="group border border-[var(--color-border)] bg-[var(--color-surface)] overflow-hidden flex flex-col hover:border-[var(--color-fg-secondary)] transition-colors"
    >
      {/* Thumbnail */}
      <div className="aspect-[16/9] bg-[var(--color-bg-secondary)] relative overflow-hidden">
        {article.thumbnail ? (
          <img
            src={article.thumbnail}
            alt={article.title}
            className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-500"
            loading="lazy"
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-[var(--color-fg-tertiary)] text-xs font-[family-name:var(--font-mono)] opacity-30">
              {article.category}
            </span>
          </div>
        )}
      </div>
      {/* Content */}
      <div className="p-5 flex flex-col flex-1">
        <div className="flex items-center gap-3 mb-3">
          <span className={`text-[10px] font-[family-name:var(--font-mono)] tracking-widest uppercase px-2 py-0.5 border ${getCategoryColor(article.category)}`}>
            {article.category}
          </span>
        </div>
        <h3 className="text-base font-medium leading-snug mb-3 group-hover:text-[var(--color-fg)] transition-colors">
          {article.title}
        </h3>
        <div className="mt-auto flex items-center gap-3 text-[10px] font-[family-name:var(--font-mono)] text-[var(--color-fg-tertiary)]">
          <span>{new Date(article.date).toLocaleDateString("en-GB", { month: "short", year: "numeric" })}</span>
          <span>·</span>
          <span>{article.readingTime} read</span>
        </div>
      </div>
    </Link>
  );
}
